import { useCallback } from 'react';

var regex = /^([0]{1}|([1-9]{1}\d*))(?:\.\d{0,2})?$/;
var simpleNumberRegx = /^\d+$/;
function useAmountValidation(setAmount, limits) {
    var onBlur = useCallback(function (event, index) {
        var value = event.target.value;
        if (regex.test(value) || value === '' || +value === 0) {
            if (value.endsWith('.')) {
                value = value.slice(0, -1);
                if (Number(value) < (limits === null || limits === void 0 ? void 0 : limits.minBet)) {
                    value = limits === null || limits === void 0 ? void 0 : limits.minBet;
                }
                else {
                    event.preventDefault();
                }
            }
            else {
                event.preventDefault();
            }
        }
        else {
            event.preventDefault();
        }
        return setAmount({ changeBet: value, index: index });
    }, [setAmount, limits]);
    var onChange = useCallback(function (event, propName) {
        var value = event.target.value;
        if (regex.test(value)) {
            setAmount({ changeValue: value, propName: propName });
        }
        if (value === '') {
            setAmount({ changeValue: value, propName: propName });
        }
    }, [setAmount]);
    var simpleOnChange = useCallback(function (event) {
        var value = event.target.value;
        if (regex.test(value)) {
            setAmount(value);
        }
        if (value === '') {
            setAmount(value);
        }
    }, [setAmount]);
    var onNumberChange = useCallback(function (event, propName) {
        var value = event.target.value;
        if (simpleNumberRegx.test(value)) {
            setAmount({ changeValue: value, propName: propName });
        }
        if (value === '') {
            setAmount({ changeValue: value, propName: propName });
        }
    }, [setAmount]);
    return { onChange: onChange, simpleOnChange: simpleOnChange, onNumberChange: onNumberChange, onBlur: onBlur };
}

export { useAmountValidation };
